import { Link } from "react-router-dom";

import { folderRoute } from "@/lib/folderUpload";

interface BreadcrumbProps {
  current: string;
}

export function Breadcrumb({ current }: BreadcrumbProps) {
  const parts = current ? current.split("/") : [];
  const accum: string[] = [];

  return (
    <nav className="flex min-w-0 items-center gap-1 overflow-hidden" aria-label="Breadcrumb">
      <Link to="/manager" className="shrink-0 text-ink-100 hover:text-emerald-200" aria-label="Home">
        <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M3 10.5 12 3l9 7.5V21a1 1 0 0 1-1 1h-5.5a1 1 0 0 1-1-1v-5.5h-3V21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V10.5z" />
        </svg>
      </Link>
      {parts.map((part, index) => {
        accum.push(part);
        const path = accum.join("/");
        const isLast = index === parts.length - 1;

        return (
          <span key={path} className="flex min-w-0 items-center gap-1">
            <span className="text-ink-500">/</span>
            {isLast ? (
              <span className="truncate font-medium text-ink-100">{part}</span>
            ) : (
              <Link to={folderRoute(path)} className="truncate text-ink-300 hover:underline">
                {part}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
